import { ButtonIcon, Card } from "@fpsoftware/mvp";
import type { ComponentProps } from "react";
import { TbExternalLink } from "react-icons/tb";
import { formatBytes } from "shared";
import { useUpload } from "@/uploads/hooks";

type UploadsCardProps = {
  uploadIDs: number[];
} & ComponentProps<typeof Card>;

export function UploadsCard(props: UploadsCardProps) {
  const { uploadIDs, ...rest } = props;
  return (
    <Card {...rest}>
      <Card.Header>Uploaded files</Card.Header>
      <Card.List>
        {uploadIDs.length === 0 ? (
          <UploadEmpty />
        ) : (
          uploadIDs.map((id) => <UploadItem key={id} uploadID={id} />)
        )}
      </Card.List>
    </Card>
  );
}

function UploadEmpty() {
  return <Card.ListItem label={<i>No files uploaded</i>} />;
}
function UploadItem(props: { uploadID: number }) {
  const upload = useUpload(props.uploadID);

  const label = (
    <span>
      {upload.name}
      <br />
      <small>{formatBytes(upload.size)}</small>
    </span>
  );

  return (
    <Card.ListItem label={label}>
      <ButtonIcon
        icon={TbExternalLink}
        onClick={() => window.open(upload.url)}
      />
    </Card.ListItem>
  );
}
